import React, { useState } from "react";
import { Route, Switch, Redirect } from "react-router";
import { Provider } from "react-redux";
import {
  Spinner, FeatureRoute, SystemFeatures,
} from "isuppli-react-components";

import store from "./store";

import AuthenticatedHandler from "./Containers/AuthenticationHandler/AuthenticationHandler";
import UserDataLoader from "./Containers/UserDataLoader/UserDataLoader";
import AppErrorBoundary from "./Containers/AppErrorBoundry/AppErrorBoundary";
import Layout from "./Containers/Layout/Layout";
import Audit from "./Sections/Audit/Audit";
import DetailedAudit from "./Sections/DetailedAudit/DetailedAudit";
import AxiosInterceptor from "./Containers/AxiosInterceptor/AxiosInterceptor";

const App = () => {
  const [loading, setLoading] = useState(true);

  return (
    <Provider store={store}>
      <AxiosInterceptor>
        <AppErrorBoundary>
          <AuthenticatedHandler>
            <UserDataLoader onLoadingDone={() => setLoading(false)}>
              <Layout>
                {loading
                  ? <Spinner />
                  : (
                    <Switch>
                      {/* Removes trailing slashes from urls */}
                      <Route
                        path="/:url*(/+)"
                        exact
                        strict
                        render={({ location }) => (
                          <Redirect to={location.pathname.replace(/\/+$/, "")} />
                        )}
                      />
                      <FeatureRoute
                        feature={SystemFeatures.AuditTrails}
                        path="/audit"
                        component={Audit}
                      />
                      <FeatureRoute
                        feature={SystemFeatures.DetailedAuditTrails}
                        path="/auditdetail"
                        component={DetailedAudit}
                      />
                      <Redirect to="/audit" />
                    </Switch>
                  )}
              </Layout>
            </UserDataLoader>
          </AuthenticatedHandler>
        </AppErrorBoundary>
      </AxiosInterceptor>
    </Provider>
  );
};

export default App;
